import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import './style.scss';
import Box from '@mui/material/Box';
import ListButton from 'component/ListButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { CloseIcon } from 'assets/images';

function ZoomMeeting(props) {
  const [meetingId, setMeetingId] = React.useState('');
  const handleChangeId = (event) => {
    setMeetingId(event.target.value);
  };
  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={props.onClose} className="dialogView">
        <DialogTitle>
          <Box className="menuTitle" onClick={props.onClose}>
            <Box>Zoom meeting</Box>

            <CloseIcon />
          </Box>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            border: '1px solid #BBBBBB',
            padding: '20px 12px !important',
            display: 'flex',
            flexDirection: 'column'
          }}>
          <TextField
            label="Enter Zoom meeting ID"
            id="outlined-size-small"
            defaultValue="Small"
            size="small"
            sx={{
              // '& legend': { display: 'none' },
              // '& fieldset': { top: 0 },
              width: '300px'
            }}
            // inputProps={{ 'aria-label': 'Without label' }}
            value={meetingId}
            onChange={handleChangeId}
            InputLabelProps={{
              style: {
                fontFamily: 'SF UI Display, sans-serif',
                fontStyle: 'normal',
                fontWeight: 300,
                fontSize: '14px',
                lineHeight: '17px',
                display: 'flex',
                alignItems: 'center',
                color: '#000'
              }
            }}
          />
          <Box sx={{ marginBottom: '12px' }} />
          <TextField
            label="Enter Zoom meeting password"
            id="outlined-size-small"
            defaultValue="Small"
            size="small"
            sx={{ width: '300px' }}
            value={meetingId}
            onChange={handleChangeId}
            InputLabelProps={{
              style: {
                fontFamily: 'SF UI Display, sans-serif',
                fontStyle: 'normal',
                fontWeight: 300,
                fontSize: '14px',
                lineHeight: '17px',
                display: 'flex',
                alignItems: 'center',
                color: '#000'
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <ListButton big onClick={props.onJoin}>
            Join Teams
          </ListButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
export default React.memo(withBoundary(ZoomMeeting));
ZoomMeeting.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onJoin: PropTypes.func
};
